import { useEffect, useState } from 'react'
import { FundingProduct } from '@frontend/components/agromarket/core/access-control'
import { getApprovedRegions } from '@/api/kubik/credit'
import type { TUseRegionsMicrocreditOrganizationsProps } from '@/utils/hooks/applyingFinancingOffer/types'

export const useRegionsMicrocreditOrganizations = ({ productId }: TUseRegionsMicrocreditOrganizationsProps) => {
  const [regionsAvailableExpressMFO, setRegionsAvailableExpressMFO] = useState<number[]>([])
  const isMFOProduct = productId === FundingProduct.EXPRESS_MFO

  useEffect(() => {
    if (isMFOProduct) {
      getApprovedRegions({ productId: FundingProduct.EXPRESS_MFO }).then(regions => {
        setRegionsAvailableExpressMFO(regions?.approvedRegions || [])
      })
    }
  }, [isMFOProduct])

  return { regionsAvailableExpressMFO, isMFOProduct }
}
